import { observable } from "mobx"

/**
 * @deprecated ~/api/student/profile/_types/ 内にある型をexportし、そちらを使用する
 * TODO(old-profile-page): 古いプロフィールの実装を消したらexportを消す
 */
export type ExperienceSoFar = {
  student: {
    id: number
    name: string
    display: string
  }[]
  programming: {
    id: number
    experience_year: string
  }
  design: {
    web_skill_id: number
    experience_year: string
  }
}

/**
 * @deprecated ~/api/student/profile/_types/ 内にある型をexportし、そちらを使用する
 * TODO(old-profile-page): 古いプロフィールの実装を消したらexportを消す
 */
export type ExperienceSoFarPut = {
  student_experience_type_ids: number[]
  programming_experience: string
  design_experience: string
}

/**
 * @deprecated ~/api/student/profile/_types/ 内にある型をexportし、そちらを使用する
 * TODO(old-profile-page): 古いプロフィールの実装を消したらexportを消す
 */
export type TExperience = {
  id: number
  company_name: string
  company: string
  country: string
  name: string
  job_type: string
  post: string
  start_on: string
  end_on: string
  ongoing: boolean
  background: string
  content: string
  learning: string
  link: string
  img_filename: string
  product_url: string
}

/**
 * @deprecated ~/api/student/profile/_types/ 内にある型をexportし、そちらを使用する
 * TODO(old-profile-page): 古いプロフィールの実装を消したらexportを消す
 */
export type Experiences = TExperience[]
interface experienceArgs {
  experience_so_far: ExperienceSoFar
  internship: Experiences
  short_internship: Experiences
  overseas_internship: Experiences
  starting_business: Experiences
  programming: Experiences
  design: Experiences
  study_abroads: Experiences
  projects: Experiences
  sports: Experiences
  seminars: Experiences
  custom_part_time_jobs: Experiences
}

export class Experience {
  @observable experience_so_far: ExperienceSoFar
  @observable internship: Experiences
  @observable short_internship: Experiences
  @observable overseas_internship: Experiences
  @observable starting_business: Experiences
  @observable programming: Experiences
  @observable design: Experiences
  @observable study_abroads: Experiences
  @observable projects: Experiences
  @observable sports: Experiences
  @observable seminars: Experiences
  @observable custom_part_time_jobs: Experiences

  constructor(args: experienceArgs) {
    this.experience_so_far = args.experience_so_far
    this.internship = args.internship
    this.short_internship = args.short_internship
    this.overseas_internship = args.overseas_internship
    this.starting_business = args.starting_business
    this.programming = args.programming
    this.design = args.design
    this.study_abroads = args.study_abroads
    this.projects = args.projects
    this.sports = args.sports
    this.seminars = args.seminars
    this.custom_part_time_jobs = args.custom_part_time_jobs
  }
}
